import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import { Tooltip } from '@mui/material';
import { cloneElement, FC, ReactElement, ReactNode } from 'react';

/** 旧画面の提供終了の予告。文言はここだけに置く */
export const SERVICE_END_NOTICE_TEXT = '2026年8月末日をもちまして、本画面のサービス提供を終了いたします。';

/** 予告の印。ホバーしなくても終了予定だと分かるように行内へ出す */
export const ServiceEndNoticeIcon: FC = () => (
  <WarningAmberOutlinedIcon
    data-testid="service-end-notice-icon"
    sx={{ ml: 'auto', fontSize: 16, color: 'warning.main' }}
  />
);

type Props = {
  /** 予告を付ける導線（メニュー項目・ボタン）。1 要素だけ受ける */
  children: ReactElement<{ children?: ReactNode }>;
};

/**
 * 提供終了を予告する導線のラッパ。ツールチップで理由を出し、行内に注意アイコンを足す。
 *
 * Why not 呼び出し側で Tooltip を書く: 旧地図画面と勤務計画で導線が 5 箇所あり、
 * 文言と見た目が散る。終了日が動いたときに直し漏れる。
 */
const ServiceEndNotice: FC<Props> = ({ children }) => {
  const withIcon = cloneElement(children, undefined, (
    <>
      {children.props.children}
      <ServiceEndNoticeIcon />
    </>
  ));

  return (
    <Tooltip title={SERVICE_END_NOTICE_TEXT} arrow placement="right">
      {/* MUI Tooltip は子に ref を渡す。ref を受けない要素も包めるように Box を挟まず、
          メニュー項目・ボタン（どちらも ref 対応）をそのまま子にする */}
      {withIcon}
    </Tooltip>
  );
};

export default ServiceEndNotice;
